import { ActionButton } from 'office-ui-fabric-react';
import PropTypes from 'prop-types';
import React from 'react';

import './Title.css';

class Title extends React.Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    onLogout: PropTypes.func.isRequired
  };

  render() {
    return (
      <div>
        <ActionButton
          iconProps={{ iconName: 'Leave' }}
          onClick={() => this.props.onLogout()}
          className="logout-btn"
        >
          Logout
        </ActionButton>
        <h1>{this.props.children}</h1>
      </div>
    );
  }
}

export default Title;



// WEBPACK FOOTER //
// ./src/components/Title/Title.js